import { createHttpClient } from '../../../api/http';
import { serviceUrls } from '../../../config/serviceUrls';
import type {
  MarkAllReadResponse,
  MarkReadResponse,
  PaginatedNotificationsResponse,
  UnreadCountResponse,
} from '../types';

export const notificationsClient = createHttpClient(serviceUrls.gateway);

export async function listNotifications(params?: {
  page?: number;
  page_size?: number;
  only_unread?: boolean;
}): Promise<PaginatedNotificationsResponse> {
  const res = await notificationsClient.get<PaginatedNotificationsResponse>('/v1/support/notifications', {
    params,
  });
  return res.data;
}

export async function getUnreadNotificationCount(): Promise<UnreadCountResponse> {
  const res = await notificationsClient.get<UnreadCountResponse>('/v1/support/notifications/unread-count');
  return res.data;
}

export async function markNotificationRead(notificationId: string): Promise<MarkReadResponse> {
  const res = await notificationsClient.patch<MarkReadResponse>(
    `/v1/support/notifications/${notificationId}/read`
  );
  return res.data;
}

export async function markAllNotificationsRead(): Promise<MarkAllReadResponse> {
  const res = await notificationsClient.patch<MarkAllReadResponse>('/v1/support/notifications/read-all');
  return res.data;
}
